// @ts-nocheck
"use client";

import { useEffect, useState } from "react";
import Loader from "./components/loader/loader";
import Pages from "./components/pages/pages";
import Footer from "./components/footer/footer";
import Content from "./components/pages/content";
import { menuInterpreter } from "./utils/menu-interpreter";
import Terms from "./components/pages/terms";
import useRoutePush from "./utils/routerPush";
import { findRedirectTarget, toSameSitePath } from "./utils/redirect-rules";
import ShowAllResults from "./components/show-all-results/show-all-results";
import { CXAHubInterpreter } from "./utils/cxa-hub-interpreter";
import Modal from "./components/atoms/modal";
import CXAContent from "./components/pages/cxa-content";

const PostClient = ({
  slugPath = ["home"],
  menuData = null,
  posts = null,
  footerData = null,
  redirectRules = null,
  vxiContent = null,
  CXAHub = null,
  industries = null,
  languages = null,
  regions = null,
  sections = null,
  solutions = null,
  types = null,
  dismissedWords = null,
  apiData = null,
}) => {
  // console.log(apiData, "api Data bruh");
  const [modal, setModal] = useState(false);

  const [interpretedCXAHub] = useState(() =>
    (Array.isArray(CXAHub) ? CXAHub : [])
      .slice()
      .sort((a, b) => (a?.episode ?? 0) - (b?.episode ?? 0))
      .map((item) => CXAHubInterpreter(item))
  );

  const [menuList] = useState(() => menuInterpreter(menuData, posts));

  const dismissedProfaneWordsList = Array.isArray(dismissedWords)
    ? dismissedWords.filter(d => d.attributes.profane).map((d) => d.attributes.Item)
    : [];

  const [redirect, setRedirect] = useState(false);
  const routePush = useRoutePush();
  useEffect(() => {
    if (!Array.isArray(redirectRules) || redirectRules.length === 0 || !slugPath) {
      return;
    }

    // Same helper the server component uses — keep both call sites in sync.
    // The server redirect already covers every full page load; this only runs
    // as a safety net (e.g. rule data changing between server render and
    // hydration). `routePush` is intentionally left out of the deps array: its
    // identity changes on every render, which would re-trigger this effect.
    const target = findRedirectTarget(redirectRules, slugPath);

    if (target) {
      setRedirect(true);
      routePush(toSameSitePath(target));
    }
  }, [redirectRules, slugPath]);

  const closeModal = async (e: React.FormEvent) => {
    // e.preventDefault();
    setModal(false);
    // routePush("/home");
  }
  const openModal = () => {
    setModal(true);
  }
  const footerAttrs = ((Array.isArray(footerData) ? footerData[0] : footerData)?.attributes) ?? {};

  const renderContent = () => {
    // A redirect is in flight — don't flash the old/empty page.
    if (redirect) {
      return <Loader />;
    }

    // CASE: when apiData exists
    if (apiData != null) {
      const source = apiData?.source;
      // content (pages)
      if (source === "content") {
        if (apiData.attributes.section?.length !== 0) {
          return (
            <Pages
              sections={apiData.attributes.section}
              menuList={menuList}
              menuDataForAutoFilter={menuData}
              footerData={footerData}
              industries={industries}
              languages={languages}
              regions={regions}
              sectionsList={sections}
              solutions={solutions}
              types={types}
              vxiContent={vxiContent}
              CXAHub={interpretedCXAHub}
              referenceList={apiData.attributes.referenceList}
              slugPath={slugPath}
            />
          );
        }
        return (
          <Loader
            mainMsg="We found your stuff!"
            subMsg="But we are still figuring out where to put them."
            status="Coming soon..."
          />
        );
      }

      // terms and policies
      if (source === "terms-and-policy") {
        return (
          <>
            {modal && <Modal handleSubmit={closeModal} />}
            <Terms terms={apiData.attributes} openModal={openModal} />
            <Footer
              footerLink={footerAttrs.footerLink}
              button={footerAttrs.button}
              socials={footerAttrs.socials}
            />
          </>
        );
      }

      // vxi-content
      if (source === "vxi-content") {
        return (
          <>
            <Content data={apiData} />
            <Footer
              footerLink={footerAttrs.footerLink}
              button={footerAttrs.button}
              socials={footerAttrs.socials}
            />
          </>
        );
      }

      // cxa-hub
      if (source === "cxa-hub") {
        return (
          <>
            <CXAContent currentCXA={apiData} all={interpretedCXAHub} />
            <Footer
              footerLink={footerAttrs.footerLink}
              button={footerAttrs.button}
              socials={footerAttrs.socials}
            />
          </>
        );
      }

      // fallback
      return (
        <>
          <>TEST</>
          <Footer
            footerLink={footerAttrs.footerLink}
            button={footerAttrs.button}
            socials={footerAttrs.socials}
          />
        </>
      );
    }

    // CASE: when apiData is null/undefined
    if (!redirect && slugPath) {
      if (slugPath === 'show-all-results') {
        return (
          <>
            <ShowAllResults posts={posts} vxiContent={vxiContent} cxaHubs={CXAHub} mostSearched={[]}
            // mostSearched={mostSearchedAggregate}
            />
            <Footer
              footerLink={footerAttrs.footerLink}
              button={footerAttrs.button}
              socials={footerAttrs.socials}
            />
          </>
        );
      }

      return <>TEST</>;
    }

    // default loader
    return <Loader />;
  };
  return (
    <div>
      {renderContent()}
    </div>
  );
};

export default PostClient;